import React from 'react'
import { Card, CardHeader, Table } from 'reactstrap'
import PropTypes from 'prop-types'
import PriceUtil from 'utils/price-util'
import TimeUtil from 'utils/time-util'
import StringUtil from 'utils/string-util'

const propTypes = {
  paymentDetail: PropTypes.shape({
    transfer_method : PropTypes.string,
    transaction_no  : PropTypes.string,
    debit_bank      : PropTypes.shape({
      bank: PropTypes.string
    }),
    transferred_evidence_image : PropTypes.string,
    transferred_at             : PropTypes.string,
    refund                     : PropTypes.shape({
      paid_item_price          : PropTypes.string,
      paid_payment_method_cost : PropTypes.string,
      paid_shipment_cost       : PropTypes.string
    })
  })
}

const defaultProps = {
  paymentDetail: {
    transaction_no : '',
    debit_bank     : {
      bank: ''
    },
    transferred_evidence_image : '',
    transferred_at             : '',
    refund                     : {
      paid_item_price          : '',
      paid_payment_method_cost : '',
      paid_shipment_cost       : ''
    }
  }
}

const CustomerRefundPaymentDetailCard        = ({ paymentDetail }) => (
  <Card>
    <CardHeader>Transfer Detail</CardHeader>
    <Table hover>
      <tbody>
        <tr>
          <th scope='row'>Refund method</th>
          <td>{ StringUtil.humanizeUpperCase(paymentDetail.transfer_method) }</td>
        </tr>
        <tr>
          <th scope='row'>Paid Item Price</th>
          <td>{ PriceUtil.format(paymentDetail.refund.paid_item_price) }</td>
        </tr>
        <tr>
          <th scope='row'>Refund Method Cost</th>
          <td>{ PriceUtil.format(paymentDetail.refund.paid_payment_method_cost) }</td>
        </tr>
        <tr>
          <th scope='row'>Refund Shipment Cost</th>
          <td>{ PriceUtil.format(paymentDetail.refund.paid_shipment_cost) }</td>
        </tr>
        <tr>
          <th scope='row'>Transaction No.</th>
          <td>{ paymentDetail.transaction_no }</td>
        </tr>
        {
          paymentDetail.transfer_method == 'cash' && (
            <tr>
              <th scope='row'>Debit Bank</th>
              <td>{ paymentDetail?.debit_bank?.bank }</td>
            </tr>
          )
        }
        <tr>
          <th scope='row'>Transferred at</th>
          <td>{ TimeUtil.format(paymentDetail.transferred_at) }</td>
        </tr>
        <tr>
          <th scope='row'>Transfer Evidence</th>
          <td>
            { paymentDetail.transferred_evidence_image ?
              <img
                src={ paymentDetail.transferred_evidence_image }
                width='60%'
                alt={ paymentDetail.transaction_no }
              />
              : '-'
            }
          </td>
        </tr>
      </tbody>
    </Table>
  </Card>
)
CustomerRefundPaymentDetailCard.propTypes    = propTypes
CustomerRefundPaymentDetailCard.defaultProps = defaultProps

export default CustomerRefundPaymentDetailCard
